import React from "react";

function KanbanIcon({ className }: { className: string }) {
  return (
    <svg viewBox="0 0 10.84 8.808" className={className}>
      <g transform="translate(-134.852 -9.259)">
        <rect
          width="9.4"
          height="1.3"
          rx="0.3"
          transform="translate(136.292 16.767)"
        />
        <rect
          width="2.1"
          height="2.1"
          rx="0.3"
          transform="translate(134.852 15.967)"
        />
        <rect
          width="9.4"
          height="1.3"
          rx="0.3"
          transform="translate(136.292 13.412)"
        />
        <rect
          width="2.1"
          height="2.1"
          rx="0.3"
          transform="translate(134.852 12.613)"
        />
        <rect
          width="9.4"
          height="1.3"
          rx="0.3"
          transform="translate(136.292 10.059)"
        />
        <rect
          width="2.1"
          height="2.1"
          rx="0.3"
          transform="translate(134.852 9.259)"
        />
      </g>
    </svg>
  );
}

export { KanbanIcon };
